export enum OrganizationStatus {
  Active = 'active',
  Expired = 'expired',
  Inactive = 'inactive',
  New = 'new',
}
